module.exports = __webpack_public_path__ + "static/media/Drama.d2c7fa68.JPG";